export function user(state) {
  return state.usuario;
}

export function perfil(state) {
  return state.perfil;
}

export function docs(state) {
  return state.docs;
}
export function bank(state) {
  return state.bank;
}
export function competence(state) {
  return state.competence;
}

export function certificates(state) {
  return state.certificates;
}

export function tools(state) {
  return state.tools;
}

export function extract(state) {
  return state.extract;
}